import { HttpClient, HttpEventType, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EnvironmentService } from '../services/enviroment.service';
import { environment } from '../services/global-environment';
import { I18nService } from './i18n.service';

import { Observable, from ,Subject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OpanaiService {

  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient, private i18nService: I18nService) { }

  public getThreadId(): Observable<{ threadid: string }> {
    return this.http.get<{ threadid: string }>(`${this.apiUrl}/api/assitant/getthreadid`);
  }

  public chatwithgpts(message: string,imageAttachments:string[] = [],threadid:string="",AImodel = "") {
    return this.http.post<any>(`${this.apiUrl}/api/gpts/chat`, { message,imageAttachments,threadid,AImodel });
  }

  public chatwithassistant(message: string,assitantid:string,threadid:string="",imageAttachments:string[] = []) {

    return this.http.post<any>(`${this.apiUrl}/api/assitant/chat`, { message,assitantid,threadid ,imageAttachments});
  }




  public chatwithassistantWithSteam(
    message: string,
    assitantid: string,
    threadid: string = "",
    companyid:string = "",
    imageAttachments: string[] = []
): Observable<string> {
    const url = `${this.apiUrl}/api/assitant/chatwithsteam`;

    const requestBody = {
        message,
        assitantid,
        threadid,
        companyid,
        imageAttachments: imageAttachments
    };

    const resultSubject = new Subject<string>();

    fetch(url, {
        method: 'POST',
        body: JSON.stringify(requestBody),
        headers: {
            "Content-Type": "application/json",
            "Accept": "text/event-stream"
        }
    })
    .then(response => {
        if (!response.ok) {
            throw new Error(`Network response was not ok: ${response.status} ${response.statusText}`);
        }
        if (!response.body) {
            throw new Error("Response body is empty.");
        }

        const reader = response.body.getReader();
        const decoder = new TextDecoder();

        function read() {
            reader.read().then(({ done, value }) => {
                if (done) {
                    resultSubject.complete();
                    return;
                }

                const chunk = decoder.decode(value, { stream: true });

                const lines = chunk.split("\n");
                for (const line of lines) {
                    if (line.startsWith("data: ")) {
                        const data = line.substring(6).trim();
                        if (data !== "[DONE]") {
                            resultSubject.next(data);
                        }
                    }
                }

                read();
            }).catch(error => {
                console.error('Error reading stream:', error);
                resultSubject.error(error);
            });
        }

        read();
    })
    .catch(error => {
        console.error('Fetch error:', error);
        resultSubject.error(error);
    });

    return resultSubject.asObservable();
}

//最新版的Response API
public chatwithOpenAIWithSteam(
  input: string,
  assistantNo: string = "",
  response_id: string = "",
  companyid: string = "",
  toolname: string[] = [],
  vector_store_id: string = "",
  imageAttachments: string[] = [],
  files?: File[],
  file_ids?: string[],
  model_version: string = "o4-mini", // 預設使用最新的模型版本
  mcpEnabledTools?: string[] // 新增 MCP 啟用工具列表參數
): Observable<string> {
  const url = `${this.apiUrl}/api/response_api/chatwithsteam`;
  const resultSubject = new Subject<string>();

  // Use FormData to support file uploads
  const formData = new FormData();
  formData.append('input', input);

  // Only append non-empty values
  if (assistantNo) formData.append('assistantNo', assistantNo);
  if (response_id) formData.append('response_id', response_id);
  if (companyid) formData.append('companyid', companyid);

  if (toolname && toolname.length > 0) {
    const toolnameString = toolname.join(';');
    formData.append('toolname', toolnameString);
  }


  if (vector_store_id) formData.append('vector_store_id', vector_store_id);

  if( model_version) formData.append('model_version', model_version);

  // 添加當前系統語系
  const currentLanguage = this.i18nService.currentLangValue;
  if (currentLanguage) formData.append('response_language', currentLanguage);

  // 添加 MCP 啟用工具列表
  if (mcpEnabledTools && mcpEnabledTools.length > 0) {
    formData.append('mcpEnabledTools', JSON.stringify(mcpEnabledTools));
  }

  // Add image attachments if any
  if (imageAttachments && imageAttachments.length > 0) {
    formData.append('imageAttachments', JSON.stringify(imageAttachments));
  }

  // Add files if provided
  if (files && files.length > 0) {
    files.forEach((file, index) => {
      formData.append('files', file, file.name);
    });
  }

    if (file_ids && file_ids.length > 0) {
    formData.append('file_ids', JSON.stringify(file_ids));
  }

  // 取得 JWT Token from localStorage
  const token = localStorage.getItem('accessToken');

  fetch(url, {
    method: 'POST',
    body: formData,
    // No Content-Type header needed - browser will set it with the correct boundary
    headers: {
      "Accept": "text/event-stream",
      // ✅ 加入 Authorization header
      ...(token ? { "Authorization": `Bearer ${token}` } : {})
    }
  })
  .then(response => {
    if (!response.ok) {
      throw new Error(`Network response was not ok: ${response.status} ${response.statusText}`);
    }
    if (!response.body) {
      throw new Error("Response body is empty.");
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder();

    function read() {
      reader.read().then(({ done, value }) => {
        if (done) {
          resultSubject.complete();
          return;
        }

        const chunk = decoder.decode(value, { stream: true });
        const lines = chunk.split("\n");

        for (const line of lines) {
          if (line.trim() === "") continue;

          try {
            // Try to parse as JSON first (for the new format)
            const jsonData = JSON.parse(line);
            resultSubject.next(line); // Send the entire JSON string
          } catch (e) {
            // If it's not valid JSON, check if it's the old format
            if (line.startsWith("data: ")) {
              const data = line.substring(6).trim();
              if (data !== "[DONE]") {
                resultSubject.next(data);
              }
            }
          }
        }

        read();
      }).catch(error => {
        console.error('Error reading stream:', error);
        resultSubject.error(error);
      });
    }

    read();
  })
  .catch(error => {
    console.error('Fetch error:', error);
    resultSubject.error(error);
  });

  return resultSubject.asObservable();
}

/**
 * 與 OpenAI 通訊但不使用流式傳輸，一次返回完整回應
 */
public chatwithOpenAI(
  input: string,
  assistantNo: string = "",
  response_id: string = "",
  companyid: string = "",
  toolname: string = "",
  vector_store_id: string = "",
  model_version: string = "",
  max_tokens: number = 16384,
  imageAttachments: string[] = [],
  files?: File[]
): Observable<any> {
  const url = `${this.apiUrl}/api/response_api/chatwithoutstream`;

  // 使用 FormData 支援檔案上傳
  const formData = new FormData();
  formData.append('input', input);

  // 僅添加非空值
  if (assistantNo) formData.append('assistantNo', assistantNo);
  if (response_id) formData.append('response_id', response_id);
  if (companyid) formData.append('companyid', companyid);
  if (toolname) formData.append('toolname', toolname);
  if (vector_store_id) formData.append('vector_store_id', vector_store_id);
  if (model_version) formData.append('model_version', model_version);
  if (max_tokens) formData.append('max_tokens', max_tokens.toString());

  // 添加當前系統語系
  const currentLanguage = this.i18nService.currentLangValue;
  if (currentLanguage) formData.append('response_language', currentLanguage);





  // 添加圖片附件（如果有）
  if (imageAttachments && imageAttachments.length > 0) {
    formData.append('imageAttachments', JSON.stringify(imageAttachments));
  }

  // 添加文件（如果提供）
  if (files && files.length > 0) {
    files.forEach((file) => {
      formData.append('files', file, file.name);
    });
  }

  // 取得 JWT Token from localStorage
  const token = localStorage.getItem('accessToken');

  // 創建一個 Observable 來處理響應
  return new Observable<string>(observer => {
    // 使用 fetch API 發送請求
    fetch(url, {
      method: 'POST',
      body: formData,
      headers: {
        // 加入 Authorization header
        ...(token ? { "Authorization": `Bearer ${token}` } : {})
      }
    })
    .then(response => {
      if (!response.ok) {
        throw new Error(`Network response was not ok: ${response.status} ${response.statusText}`);
      }
      return response.json();
    })
    .then(data => {
      // 根據API返回格式提取內容
      if (data.success && data.content) {
        // 使用API返回的content字段
        observer.next(data);
      }
      observer.complete();
    })
    .catch(error => {
      console.error('Fetch error:', error);
      observer.error(error);
    });
  });
}





  //這個不知道做什麼用的，之後要合併掉
  public chatWithAssistantSSE(userMessage: string, assistantId: string): Observable<string> {
    return new Observable<string>((observer) => {

      let apiurl = `${this.apiUrl}/api/assitant/chatwithassistant?message=${userMessage}&assistantid=${assistantId}`;

      console.log('apiurl:', apiurl);

      const eventSource = new EventSource(apiurl);

      eventSource.onmessage = (event) => {
        const reply = event.data;

        if (reply === '[DONE]') {
          eventSource.close(); // 關閉連接
          observer.complete();  // 完成 Observable
        } else {
          observer.next(reply);  // 發送新訊息給訂閱者
        }
      };

      eventSource.onerror = (error) => {
        observer.error(error);  // 錯誤處理
      };

      // 當 Observable 被取消訂閱時關閉 SSE 連接
      return () => {
        eventSource.close();
      };
    });
  }


  public getfilelist(vector_store_id: string, companyid: string, assistantNo?: string) {
    // 加上時間戳記避免快取問題
    const timestamp = new Date().getTime();
    const payload: any = {
      vector_store_id,
      companyid
    };

    // assistantNo 是選填參數
    if (assistantNo) {
      payload.assistantNo = assistantNo;
    }

    return this.http.post<any>(`${this.apiUrl}/api/vectordb/getfilelist?_t=${timestamp}`, payload);
  }

  public getFilesExtraInfo(companyid: string, vectorStoreId: string) {
    return this.http.post<any>(`${this.apiUrl}/api/vectordb/getUploadFilesExtraInfo`, {
      companyid,
      vectorStoreId
    });
  }

  public saveTag(companyid: string, vectorStoreId: string, fileid: string, filename: string, azureUrl: string | null, tags: string[], uploadedAt?: string) {
    return this.http.post<any>(`${this.apiUrl}/api/vectordb/savetag`, {
      companyid,
      vectorStoreId,
      fileid,
      filename,
      azureUrl,
      tags,
      uploadedAt
    });
  }

  public updateFileAttributes(companyid: string, fileId: string, tags: string[]) {
    return this.http.post<any>(`${this.apiUrl}/api/vectordb/updateFileAttributes`, {
      companyid,
      file_id: fileId,
      tags
    });
  }

  public deletefile(vector_store_id: string, id: string, companyid: string) {
    return this.http.post<any>(`${this.apiUrl}/api/vectordb/deletefile`, {
      vector_store_id,
      id,
      companyid
    });
  }

  public uploadFiles(
    files: File[],
    vector_store_id: string,
    companyid: string,
    assistantNo: string,
    created_by: string
  ): Observable<any> {
    const formData = new FormData();

    // 將檔案添加到 formData
    files.forEach((file) => {
      formData.append('files', file, file.name);
    });

    // 添加必要參數到 formData
    formData.append('vector_store_id', vector_store_id);
    formData.append('companyid', companyid);
    formData.append('assistantNo', assistantNo);
    formData.append('created_by', created_by);

    // 發送 POST 請求，返回 Observable，並監控上傳進度
    return this.http.post<any>(`${this.apiUrl}/api/vectordb/upload`, formData, {
      headers: new HttpHeaders({
        'Accept': 'application/json',
      }),
      reportProgress: true, // 設置為 true 以獲取進度事件
      observe: 'events', // 觀察所有事件
    });
  }


}
